import { render, staticRenderFns } from "./leaveInfoCard.vue?vue&type=template&id=5057360d"
import script from "./leaveInfoCard.vue?vue&type=script&lang=js"
export * from "./leaveInfoCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports